/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */
let baseUrl = 'https://saas.hansifit.com/api/';
let websocketUrl = 'wss://saas.hansifit.com/JbvZhE';

if (process.env.NODE_ENV == 'development') {
    baseUrl = 'https://saas.hansifit.com/api/';
    websocketUrl = 'wss://saas.hansifit.com/JbvZhE';
} else if (process.env.NODE_ENV == 'production') {
    baseUrl = 'https://saas.hansifit.com/api/';
    websocketUrl = 'wss://saas.hansifit.com/JbvZhE';
}
export {
    baseUrl,
    websocketUrl,
};
